import React, { useState, useEffect, useMemo } from "react";
import "../App.css";
import SearchBar from "./SearchBar";
import JobCard from "./JobCard";
import JobDetails from "./JobDetails";

const JobListings = ({ jobs, loading }) => {
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [filteredJobs, setFilteredJobs] = useState(jobs);
  const [showAllConnections, setShowAllConnections] = useState(false);

  useEffect(() => {
    setFilteredJobs(jobs);
    if (!selectedJobId && jobs.length > 0) {
      setSelectedJobId(jobs[0].job_url);
    }
  }, [jobs, selectedJobId]);

  const selectedJob = useMemo(() => {
    return filteredJobs.find(job => job.job_url === selectedJobId);
  }, [filteredJobs, selectedJobId]);

  const handleSearchResults = (results) => {
    setFilteredJobs(results);
    if (results.length > 0 && !results.find(job => job.job_url === selectedJobId)) {
      setSelectedJobId(results[0].job_url);
    }
  };

  const handleJobSelect = (jobUrl) => {
    setSelectedJobId(jobUrl);
    setShowAllConnections(false);
  };

  if (loading) return <div className="loading-state">Loading jobs...</div>;
  if (!jobs.length) return <div className="no-jobs">No jobs found</div>;

   return (
  //   <div>
  //     {jobs.length > 0 && (
  //       <div className="job-listings-search">
  //         <SearchBar 
  //           jobs={jobs} 
  //           onSearchResults={setFilteredJobs} 
  //         />
  //       </div>
      // )}
      <div className="job-listings-container">
        <div className="job-cards">
          {filteredJobs.map((job) => (
            <JobCard
              key={job.job_url}
              job={job}
              isSelected={job.job_url === selectedJobId}
              onSelect={setSelectedJobId}
            />
          ))}
        </div>

        <JobDetails 
          job={selectedJob}
          showAllConnections={showAllConnections}
          onToggleConnections={() => setShowAllConnections(!showAllConnections)}
        />
      </div>
    // </div>
  );
};

export default JobListings;